import { useState, useEffect } from 'react'

import HomePage from './components/homePage/HomePage'
import NavBar from './components/navBar/NavBar'
import Wolcome from './components/content/wolcome/Wolcome'
import UpButton from './components/upButton/UpButton'

import './App.css'

function App() {
  const [employeeType, setEmployeeType] = useState(0)
  const [showUpButton, setShowUpButton] = useState(false)

  const [observedModels, setObservedModels] = useState(() => {
    const storedData = localStorage.getItem('observedModels')

    return storedData
      ? JSON.parse(storedData)
      : {
          workingInSpace: false,
          health: false,
          food: false,
          allAround: false,
          pension: false,
          important: false
        }
  })

  useEffect(() => {
    localStorage.setItem('observedModels', JSON.stringify(observedModels))
  }, [observedModels])

  const handleScrollToSection = (
    sectionId,
    accordionId = null,
    uniqueId = null
  ) => {
   
    const targetSaction = document.getElementById(sectionId)
    const targetElement = uniqueId
      ? document.getElementById(uniqueId)
      : document.getElementById(sectionId)

    if (targetElement && targetSaction) {
      const openAccordionEvent = new CustomEvent('openAccordion', {
        detail: { accordionId },
      })
      targetSaction.dispatchEvent(openAccordionEvent)

      const time = uniqueId ? 300 : 0
      // setTimeout(() => {
      //   targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      // }, time)

      setTimeout(() => {
        // Get target element's position
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY
        const offset = 100 // Adjust scrolling position by 50px above the target

        // Scroll smoothly to the adjusted position
        window.scrollTo({
          top: targetPosition - offset,
          behavior: 'smooth',
        })
      }, 300)
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY
      const screenHeight = window.innerHeight

      setShowUpButton(scrollPosition > screenHeight / 2)
    }
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className="main_page_container">
      {!employeeType ? (
        <Wolcome setEmployeeType={setEmployeeType} />
      ) : (
        <>
          <div className="content">
            <HomePage
              onNavigate={handleScrollToSection}
              handleScrollToSection={handleScrollToSection}
            />
          </div>
          {employeeType === 2 && (
            <div className="nav_bar">
              <NavBar
                onNavigate={handleScrollToSection}
                observedModels={observedModels}
                setObservedModels={setObservedModels}
              />
            </div>
          )}
          {showUpButton && (
            <UpButton handleScrollToSection={handleScrollToSection} />
          )}
        </>
      )}
    </div>
  )
}

export default App
